import { useState, useEffect } from "react";
import { Dropdown, Form } from "react-bootstrap";
import PropTypes from 'prop-types';

function FuncionarioFilter({ funcionarios, selectedFuncionarios, onFuncionariosChange, loading }) {
  const [dropdownAbierto, setDropdownAbierto] = useState(false);
  const [todosSeleccionados, setTodosSeleccionados] = useState(true);

  useEffect(() => {
    setTodosSeleccionados(selectedFuncionarios.length === funcionarios.length);
  }, [selectedFuncionarios, funcionarios]);

  const handleCheckboxChange = (funcionarioId) => {
    if (selectedFuncionarios.includes(funcionarioId)) {
      // Si ya está seleccionado, quitarlo
      const nuevosSeleccionados = selectedFuncionarios.filter(id => id !== funcionarioId);
      onFuncionariosChange(nuevosSeleccionados);
    } else {
      // Si no está seleccionado, agregarlo
      onFuncionariosChange([...selectedFuncionarios, funcionarioId]);
    }
  };

  const toggleTodos = () => {
    if (todosSeleccionados) {
      // Deseleccionar todos
      onFuncionariosChange([]);
    } else {
      // Seleccionar todos
      const todosIds = funcionarios.map(f => f.id);
      onFuncionariosChange(todosIds);
    }
  };

  return (
    <Dropdown 
      show={dropdownAbierto} 
      onToggle={(isOpen) => setDropdownAbierto(isOpen)}
    >
      <Dropdown.Toggle 
        variant="outline-primary" 
        size="sm"
        id="dropdown-funcionarios"
        className="d-flex align-items-center gap-2 w-100"
        disabled={loading}
      >
        <i className="bi bi-funnel"></i>
        Funcionarios ({selectedFuncionarios.length})
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ minWidth: "300px", maxHeight: "400px", overflowY: "auto" }}>
        <div className="px-3 py-2">
          <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
            <small className="text-muted fw-semibold">Seleccionar funcionarios</small>
            <button 
              className="btn btn-link btn-sm text-decoration-none p-0"
              onClick={toggleTodos}
              style={{ fontSize: "0.85rem" }}
            >
              {todosSeleccionados ? "Limpiar" : "Todos"}
            </button>
          </div>
          
          {funcionarios.map((funcionario) => (
            <div key={funcionario.id} className="py-1">
              <Form.Check
                type="checkbox"
                id={`funcionario-${funcionario.id}`}
                label={funcionario.nombre}
                checked={selectedFuncionarios.includes(funcionario.id)}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange(funcionario.id);
                }}
                onClick={(e) => e.stopPropagation()}
                className="user-select-none"
              />
            </div>
          ))}
          
          {selectedFuncionarios.length === 0 && (
            <small className="text-danger d-block mt-2 pt-2 border-top">
              Selecciona al menos un funcionario
            </small>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

FuncionarioFilter.propTypes = {
  funcionarios: PropTypes.array.isRequired,
  selectedFuncionarios: PropTypes.array.isRequired,
  onFuncionariosChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FuncionarioFilter.defaultProps = {
  loading: false,
};

export default FuncionarioFilter;
